<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ReminderListsTabs from '../../components/Reminders/ReminderListsTabs';
import TwOverlay from '../../components/TwOverlay';
import utility from '../../mixins/utility';

export default {
  name: 'ReminderLists',
  components: {
    TwOverlay,
    ReminderListsTabs,
  },
  mixins: [
    utility,
  ],
  computed: {
    ...mapState({
      preview: state => state.reminders.lists.preview,
      overview: state => state.reminders.lists.overview,
    }),
    ...mapGetters({
      getOverviewPoints: 'reminders/getOverviewPoints',
    }),
    active() {
      return this.$route.matched.length === 2;
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      getPreviewData: 'reminders/getPreviewData',
      getOverview: 'reminders/getOverview',
    }),
    initBreadcrumbs() {
      this.setBreadcrumbs({
        breadcrumbs: [
          { text: 'Reminders', to: '', disabled: true },
          { text: 'Lists', to: this.$route.path },
        ],
        title: 'Lists',
      });
    },
    loadOverview() {
      if (this.overview.loading || this.overview.item) {
        return;
      }
      this.getOverview();
    },
  },
  created() {
    this.initBreadcrumbs();
    if (!this.preview.item) {
      this.getPreviewData();
    }
  },
  watch: {
    active() {
      if (this.active) {
        this.initBreadcrumbs();
      }
    },
  },
};
</script>
<template>
  <v-flex xs12>
    <reminder-lists-tabs/>
    <v-container>
      <router-view v-if="!active"/>
      <v-layout v-else wrap reminder-lists>
        <tw-overlay :visible="preview.loading"/>
        <v-progress-circular v-if="preview.loading" class="reminder-lists__loading" indeterminate/>
        <v-flex xs12 mb-1>
          <h1>General Information</h1>
        </v-flex>
        <v-flex xs6>
          <span class="subheading">
            Information below is across all domains
          </span>
        </v-flex>
        <v-flex xs6>
          <span class="subheading">
            List Overview
          </span>
        </v-flex>
        <v-flex xs6 mt-3>
          <v-layout>
            <v-flex xs12>
              <h3 class="d-inline">Current Status:</h3>
              <span v-if="!preview.item">-</span>
              <span v-else-if="preview.item.reminderStatus" class="green--text subheading pl-2">Active</span>
              <span v-else class="red--text subheading pl-2">Inactive</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <h3 class="d-inline">Active Reminders:</h3>
              <span v-if="!preview.item">-</span>
              <span v-else class="subheading pl-2">{{ preview.item.activeReminders }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex :class="{ 'grey lighten-3': !overview.item }" xs6 mt-3 reminder-lists__overview @click="loadOverview">
          <v-progress-circular v-if="overview.loading" class="reminder-lists__loading" indeterminate/>
          <div v-else-if="overview.item">
            <div v-for="point in getOverviewPoints" :key="point.value">
              <h3 class="d-inline">{{ point.label }}:</h3>
              <span class="body-2">{{ overview.item[point.value] }}</span>
            </div>
          </div>
          <span v-else class="reminder-lists__overview-text title">Click to load</span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<style lang="scss">
.reminder-lists {
  position: relative;

  &__loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  &__overview {
    height: 200px;
    width: 100%;
    border-radius: 5px;
    position: relative;
    cursor: pointer;

    &-text {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reminders/ReminderLists.vue